module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "login-title"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', [_vm._v("DEAD END")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2385a137!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/404.vue
// module id = 151
// module chunks = 2